import SectionMessage from '@atlaskit/section-message';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const FreeExtensionAppliedMessage = () => (
  <SectionMessage>
    <FormattedMessage
      id="mac.licenses.free-extension-applied"
      defaultMessage="Free extension applied."
    />
  </SectionMessage>
);
